<template>
  <v-container>
    <div class="d-flex flex-column align-center mt-4 text-center">
      <h2>Urlaubswünsche</h2>
    </div>

    <v-list class="mt-4">
      <v-list-item v-for="vacationPeriod in sortedVacationPeriods" :key="vacationPeriod.year">
        <div v-if="!vacationPeriod.hidden" :class="[
        !vacationPeriod.locked ?  '' : 'transparent',
        'gradient',
        'shadow',
        'round-corners',
        'responsive',
        clickedItem === vacationPeriod.year ? 'click-animation' : '']"
             @click="navigateToVacation(vacationPeriod)">
          <v-row >
            <v-col>
              <v-list-item-title>{{ vacationPeriod.year }}</v-list-item-title>
              <v-col class="pa-0 ma-0 text-subtitle-2">
                <div>
                  Deadline: <b>{{ vacationPeriod?.deadline.toDate().toLocaleDateString('de-DE') }}</b>
                </div>
              </v-col>
            </v-col>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <small v-if="!vacationPeriod.locked">Urlaubswunsch erfassen</small>
              <small v-else>Urlaubswunsch ansehen</small>
            </v-col>
          </v-row>
        </div>
      </v-list-item>
    </v-list>
    
    <v-container class="text-center" v-if="vacationCount === 0">
      <small>Keine Urlaubszeiträume gefunden!</small>
    </v-container>
  </v-container>
</template>

<script lang="ts">
import {useCollection} from "vuefire";
import {collection} from "firebase/firestore";
import {db} from "@/main";
import {computed, ref} from "vue";
import router from "@/router";

export default {
  setup(){
    const vacationPeriods = useCollection(collection(db, 'vacationPeriods'));
    
    const sortedVacationPeriods = computed(() => {
      return vacationPeriods.value.slice().sort((a, b) => b.year - a.year);
    });
    
    const vacationCount = computed(() => {
      return vacationPeriods.value.filter(period => period.hidden === false).length;
    });
    
    const clickedItem = ref<number | null>(null);
    const navigateToVacation = (item: any) => {
      clickedItem.value = item.year;
      setTimeout(() => {
        clickedItem.value = null;
      }, 300); // Duration of the animation
      router.push(`/urlaubswunsch/${item.year}`);
    };
    
    return {vacationPeriods, clickedItem, navigateToVacation, vacationCount, sortedVacationPeriods};
  }
}
</script>

<style scoped>
.wrap-text {
  word-wrap: break-word;
}

.gradient {
  color: var(--new-primary-weiß);
  background-image: linear-gradient(90deg,
  rgba(0, 75, 160, 1) 0%,
  rgba(37, 31, 117, 1) 100%);
}

.round-corners {
  border-radius: 5px;
}

.shadow {
  box-shadow: 0 0 20px rgba(34, 38, 47, 0.1);
}


.transparent {
  background-image: linear-gradient(90deg,
  rgba(0, 75, 160, 0.6) 0%,
  rgba(37, 31, 117, 0.8) 100%);
}

.responsive {
  padding: var(--new-responsive-space);
}

.click-animation {
  animation: clickEffect 0.3s ease;
}

@keyframes clickEffect {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.80);
  }
  100% {
    transform: scale(1);
  }
}
</style>